import { Button, Flex } from "antd"
import { type BaseOptionType } from "antd/lib/select"

import { SearchBar } from "../../../../components/Input/SearchBar.tsx"
import { type ProposalFilters } from "../../redux/proposals.types.ts"

interface ProposalsSidebarHeaderProps {
  filters: ProposalFilters
  statuses: BaseOptionType[]
  onFilterChange: (key: keyof ProposalFilters, value: string | null) => void
}

export function ProposalsSidebarHeader({
  filters,
  statuses,
  onFilterChange
}: ProposalsSidebarHeaderProps) {
  return (
    <Flex vertical gap={"middle"} className={"border-b pr-2 border-border"}>
      <SearchBar
        defaultValue={filters?.q || ""}
        onSearch={(v) => onFilterChange("q", v)}
        placeholder={"Search proposals..."}
      />

      <Flex gap={"small"} className={"overflow-x-scroll tailwind-scroll"}>
        {statuses?.map((s) => (
          <Button
            key={s?.value}
            size={"small"}
            variant={"solid"}
            onClick={() => onFilterChange("status", s?.value)}
            type={s?.value === filters?.status ? "primary" : "default"}
          >
            {s?.label}
          </Button>
        ))}
      </Flex>
    </Flex>
  )
}
